import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Se il ruolo e' richiesto e l'utente non ce l'ha
  if (requiredRole && user) {
    let hasRequiredRole = false;
    
    if (Array.isArray(requiredRole)) {
      // Se requiredRole è un array, controlla se l'utente ha almeno uno dei ruoli
      hasRequiredRole = requiredRole.some(role => user.roles.includes(role));
    } else {
      // Se requiredRole è una stringa, controlla se l'utente ha quel ruolo
      hasRequiredRole = user.roles.includes(requiredRole);
    }
    
    if (!hasRequiredRole) {
      // Redirect based on user's highest role
      if (user.roles.includes('admin')) {
        return <Navigate to="/admin" replace />;
      } else if (user.roles.includes('teacher')) {
        return <Navigate to="/teacher" replace />;
      } else {
        return <Navigate to="/profile" replace />;
      }
    }
  }

  return children;
};

export default ProtectedRoute; 